/* eslint-disable import/prefer-default-export */

// 方法命名默认以Unique+功能格式命名，方便维护开发
// call
/**
 * 退出登陆
 * @export
 * @param {*} config type: 0, // 0: 退出登录， 1: 注销账户
 * @param {*} [callback=() => {}]
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * { ‘code’ : '0', 'msg' : "", 'data' : "" }
 */
export function UniqueLogout(config = {}, callback = () => {}) {
  window.localStorage.clear();
  window.UniqueJSBridgeProxy.call('userState.logout', config, callback);
}

/**
 * 获取数据
 * @export
 * @param {*} config type: 'common' key: "customKey"
 * @param {*} [callback=() => {}]
 * JSON.stringify(result).code  0:成功 -1：失败（入参无效）;
 * JSON.stringify(result).data.key 目标值，code=-1时为空
 * JSON.stringify(result).msg 描述
 */
export function UniqueGetData(config = {}) {
  return new Promise(resolve => {
    try {
      window.UniqueJSBridgeProxy.call(
        'dataStorage.getData',
        config,
        result => {
          resolve(result);
        },
      );
    } catch (e) {
      resolve(e);
    }
  });
}

/**
 * 支付
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config :
 * type: 微信 : wxpay , 支付宝支付 : alipay
 * data: 支付宝为字符串，微信为 {"noncestr" : "", "package" : "", "partnerid" : "", "prepayid" : "", "sign" : "", "timestamp" : ""}
 * url: 保留统计用url
 * result {'type': 'wxpay', 'status': 1} status : 支付成功 : 0, 支付失败 ：-1， 支付取消 ： 1
 */
export function UniqueNativePay(config = {}, callback = () => {}) {
  window.UniqueJSBridgeProxy.call('pay.nativePay', config, callback);
}

/**
 * 后退
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config :{"animation":true, // 是否带动画推出界面，默认yes"index":"1","jsFunName" : "回退页面前需要执行的js函数名"
 */
export function UniquePopTo(config = {}, callback = () => {}) {
  window.UniqueJSBridgeProxy.call('jump.popTo', config, callback);
}

/**
 * 跳转原生页面
 */
export function UniqueJumpToPage({ path, isNoJump = false }) {
  const urlObj = {
    index: 'pomelo://com.black.pomelo/main/MainActivity?tabId=index',
    mine: 'pomelo://com.black.pomelo/main/MainActivity?tabId=mine',
    LoginActivity: 'pomelo://com.black.pomelo/main/login/LoginActivity',
    SearchActivity: 'pomelo://com.black.pomelo/main/main/SearchActivity',
  };
  const url = urlObj[path] || '';
  if (!isNoJump) {
    window.location.href = url;
  } else {
    return url;
  }
}

/**
 * 获取app版本 ios
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * result.data.version
 */
export function UniqueGetAppVersion(config = {}, callback = () => {}) {
  window.UniqueJSBridgeProxy.call('app.web_getAppVersion', config, callback);
}

/**
 * 获取app版本 安卓
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * result.data.versionName
 */
export function UniqueGetAppVersionName(config = {}, callback = () => {}) {
  window.UniqueJSBridgeProxy.call('app.web_getAppVersionName', config, callback);
}

/**
 * 通知原生更新数据
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * result.data.versionName
 */
export function UniqueBalanceChange(config = {}, callback = () => {}) {
  try {
    window.UniqueJSBridgeProxy.call('userState.balanceChange', config, callback);
  } catch (e) {
    console.log(e);
  }
}

/**
 * 获取用户信息
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * result.data.versionName
 */
export function UniqueUserState(config = {}) {
  return new Promise(resolve => {
    try {
      window.UniqueJSBridgeProxy.call('userState.getUserData', config, res => {
        resolve(res);
      });
    } catch (e) {
      console.log(e);
      resolve(e);
    }
  });
}


/**
 * 移除原生路由栈中指定页面（根据页面的startpage做字符匹配）
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * result.data.versionName
 */
export function UniqueDestroyPage(config = {}, callback = () => {}) {
  try {
    window.UniqueJSBridgeProxy.call('jump.destroyPage', config, callback);
  } catch (e) {
    console.log(e);
  }
}

/**
 * 热云上报支付统计
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config {"transactionId":"流水号","paymentType":"alipay/unionpay/weixinpay","currencyType":"CNY人民币、USD美金",currencyAmount:10.0}
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * result.data.versionName
 */
export function UniquerReYunTrakingPayment(config = {}, callback = () => {}) {
  try {
    window.UniqueJSBridgeProxy.call('analytics.setTrakingPayment', config, callback);
  } catch (e) {
    console.log(e);
  }
}

/**
 * 热云上报自定义事件
 * @export
 * @param {*} config
 * @param {*} [callback=() => {}]
 * config {"eventName":"event_1 - event_12", "param":{}}
 * result.code == 0 成功，result.code == -1失败，此时result.msg 为对应错误码
 * result.data.versionName
 */
export function UniquerReYunTrackingEvent(config = {}, callback = () => {}) {
  try {
    window.UniqueJSBridgeProxy.call('analytics.setTrackingEvent', config, callback);
  } catch (e) {
    console.log(e);
  }
}


// register 监听
/**
 * 获监听页面返回
 * 拦截监听导航栏左上角返回按钮，以及Android的物理返回键和ios的手势返回
 */
export function UniqueRegisterBack(callback = () => {}) {
  window.UniqueJSBridgeProxy.register('back', callback);
}
